export type BaseDisclaimer = {
  kind: DisclaimerKind;
  id: number | null;
  text: string;
  startDate: string | null;
  endDate: string | null;
  priority: number;
  temporaryId: number;
};

export enum DisclaimerKind {
  ADVICE = 'ADVICE',
  ALERT = 'ALERT',
  IMPORTANT_INFORMATION = 'IMPORTANT_INFORMATION',
}

export type HotelDisclaimer = BaseDisclaimer & {
  kind: DisclaimerKind;
  hotelId: number;
};

export type PackageDisclaimer = BaseDisclaimer & {
  kind: DisclaimerKind;
  packageId: number;
};
